if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      //PKS change start — variant availability text: cache the title element and its true default (rich text) content. Sourced from data-default-title, not innerHTML — innerHTML may already show an override if this variant was pre-selected on load.
      this.titleEl = this.querySelector('.js-pks-availability-title');
      this.defaultTitleHtml = this.titleEl ? this.titleEl.dataset.defaultTitle : '';
      //PKS change end

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
        //PKS change start — variant availability text: swap the title to this variant's override, falling back to the default when it has none
        this.updateAvailabilityTitle(inventory.availability_text);
        //PKS change end
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     * Updates the availability title to the given variant-specific text,
     * falling back to the block's default (rich text) title when blank.
     * PKS Changes — Variant Availability Text
     * @param {?string} text - Variant-specific override text, if any.
     */
    updateAvailabilityTitle(text) {
      if (!this.titleEl) return;

      if (text) {
        this.titleEl.textContent = text;
      } else {
        this.titleEl.innerHTML = this.defaultTitleHtml;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;
      
      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
          //PKS change start
          // Intentional (confirmed by the client, 13 Oct): the low-stock message is shown only for clearance items.
          // Regular stocked items show the real count while stock is 10+, below that they default to "In Stock"
          // until replenished, because stock is always in transit. Do not "fix" this; carry it over as is.
        // } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
        } else if (inventoryLevel !== 'in_stock' && inventoryPolicy !== 'deny' && inventoryLevel != 'normal' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          if (this.dataset.inClearance === 'true') {
            this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
          } else {
            inventoryLevel = 'in_stock';
            this.setAttribute('data-inventory-level', inventoryLevel);
            this.inventoryNotice.innerText = '';
          }
        } else if (inventoryLevel !== 'in_stock' && inventoryLevel !== 'very_low' && inventoryLevel !== 'low' && (this.dataset.showCount === 'always' /*|| (this.dataset.showCount === 'low' && inventoryLevel.includes('low'))*/)) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'very_low') {
          if (this.dataset.inClearance === 'true') {
            this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
          } else {
            this.inventoryNotice.innerText = '';
            inventoryLevel = 'in_stock';
            this.setAttribute('data-inventory-level', inventoryLevel);
          }
        } else if (inventoryLevel === 'low') {
          if (this.dataset.inClearance === 'true') {
            this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
          } else {
            inventoryLevel = 'in_stock';
            this.setAttribute('data-inventory-level', inventoryLevel);
            this.inventoryNotice.innerText = '';
          }
          //PKS change end
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          // this.inventoryNotice.innerText = theme.strings.inStock;
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }
          
        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        //PKS change start
        // this.hidden = true;
        this.hidden = false;
        // inventoryLevel = 'in_stock';
        this.setAttribute('data-inventory-level', inventoryLevel);
        // this.inventoryNotice.innerText = theme.strings.inStock;
        this.inventoryNotice.innerText = '';
        //PKS change end
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}